import React, { Component } from 'react';
import { Button, Modal } from 'react-responsive-ui'
import PropTypes from 'prop-types';
import Loading from '../components/Loading';
import { getPostsListForUser } from '../helpers/registrationHelper';
import PostsList from '../components/newsline/postsList';
import Dashboard from '../view/dashboard';
import Measures from '../view/measures';
import More from '../components/more';

class FriendProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.history.location.state.user,
            displayPosts: props.history.location.state.displayPosts
        } 
       
        getPostsListForUser(this.state.user.user_id)
            .then((response) => {
                if (!response.data.error) {
                    this.setState({ posts: response.data })
                } else {
                    console.log('get posts errored')
                }
            })
    }

    componentWillMount = () => {
        this.setState({ableToLoadMore: true})
    }

    measureTypeSelected = (measure_type) => {
        this.setState({ measure_type_id: measure_type, showMeasures: true})
    }

    render() {
        if (!this.state) {
            return <Loading />
        } else {
            return (
                <div className="adas">
                    User profile {this.state.name}
                    <img className="profile-picture" src={this.state.user.picture} />
                    <Button className="switch-btn" action={() => { this.switchDisplay() }}> Switch view </Button>
                    <div className="newsline-wrapper">
                        {this.state && this.state.posts && this.state.displayPosts && <PostsList posts={this.state.posts} />}
                        {this.state && this.state.posts && this.state.displayPosts && <More loadMore={this.loadMore} ableToLoadMore={this.state.ableToLoadMore} />}
                    </div> 
                    {this.state && !this.state.displayPosts && <Dashboard {...this} itemSelected={this.measureTypeSelected} user_id={this.state.user_id}/>}
                    {this.state && !this.state.displayPosts && this.state.measure_type_id && 
                    <Modal
                    isOpen={this.state.showMeasures}
                    close={() => this.setState({ showMeasures: false })}>
                    <Measures measure_type_id={this.state.measure_type_id} user_id={this.state.user_id}/>
                    </Modal>}
                </div>
            )
        }
    }

    loadMore = (pageNumber) => {
        getPostsListForUser(this.state.user_id, pageNumber)
            .then((response) => {
                if (!response.data.error) {
                    if(response.data.length > 0 )
                        this.setState(prevState => ({ posts: prevState.posts.concat(response.data) }))
                        else
                        this.setState({ ableToLoadMore: false})

                } else {
                    console.log('get posts errored')
                }
            })
    }
    
    switchDisplay = () => {
        this.setState(prevState => ({displayPosts: !prevState.displayPosts}))
    }
}

FriendProfile.propTypes = {
    history: PropTypes.object
};
export default FriendProfile;


// WEBPACK FOOTER //
// ./src/containers/friendProfile.js